// PG-2492: Surmount-controlled definitions for strategy key_stats labels.
// Wording is fixed here (not the backend) because the definitions are part
// of a compliance requirement — SEC Rule 206(4)-1: presenting unexplained
// statistics alongside performance figures can be misleading if a retail
// client cannot interpret them. Text below is copied verbatim from the
// PG-2492 acceptance criteria — do not "polish" (no added punctuation,
// no rephrasing, no fixing of "it's" → "its").

export const METRIC_DEFINITIONS = {
  "Asset Classes": "Asset classes traded by this strategy",
  "Annual Return":
    "Average annual return per year of this strategy over it's lifetime",
  CAGR: 'Compound annual growth rate equation, where the "years" value is the calendar span between the first and last dates of backtested data divided by 365.25 (to account for weekends and holidays)',
  "Return Factor":
    'Ending portfolio value divided by the starting portfolio value (e.g. "1.50" means a 50% return)',
  "Trades per Day": "Average number of trades placed per day",
  // Same definition under the casing the backend currently emits in mockData.
  "Trades Per Day": "Average number of trades placed per day",
  "Calmar Ratio":
    "Measure of risk-adjusted returns = (average annual rate of return / maximum drawdown)",
  "Standard Deviation":
    "Measure of how data points are from the average - high standard deviation means higher price fluctuations",
  "Alpha Capacity":
    "How much liquidity can be traded using this strategy effectively in $-value",
  "Risk Score":
    "Proprietary Surmount risk score ranging from 0 (least risky) to 5 (most risky)",
  "Total Trades":
    "Total number of trades placed over the strategy testing period (not including backtesting)",
  "Losing Trades":
    "Total number of losing trades placed over the strategy testing period (not including backtesting)",
  "Winning Trades":
    "Total number of winning trades placed over the strategy testing period (not including backtesting)",
  "Days Active": "Number of days this strategy has been actively trading",
  "Maximum Drawdown":
    "Maximum observed loss from a peak to a trough of a portfolio, until a new peak is observed",
  "Benchmark Max Drawdown":
    "Maximum Drawdown of the benchmark comparison (SPY)",
  "Total Return":
    "Total percentage return from the start of strategy testing until now",
  "Profit Factor":
    "The probabilistic expected value when exiting a trade - greater than 1 is good, less than 1 is bad",
  "Absolute Drawdown": "Maximum percent drawdown from the initial capital",
  "Sharpe Ratio":
    "Annualized Sharpe Ratio - expected excess return / standard deviation of excess return",
  "Diversification Factor":
    "For each bar, compute the inverse Herfindahl Index, then average across all bars, leading to a higher value meaning higher diversification",
  "Consecutive Losing Trades":
    "Number of consecutive losing trades (including backtesting)",
  "Consecutive Winning Trades":
    "Number of consecutive winning trades (including backtesting)",
  "Pattern Day Trading":
    "Whether this strategy performs pattern day trades (PDT)",
};

export const HIDDEN_METRICS = new Set([
  "Recommended Allocation",
  "Total Trades",
  "Losing Trades",
  "Winning Trades",
  "Days Active",
]);

export const isHiddenMetric = (name) => HIDDEN_METRICS.has(name);

export const getMetricDefinition = (name) => METRIC_DEFINITIONS[name];
